module.exports = __webpack_public_path__ + "static/media/bg-image-24.8b2a7dd9.jpg";